import React from 'react';
import PropTypes from 'prop-types';
import { Dthc } from '../../../Modules';
import TitleTextArea from './TitleTextArea';
import styles from '../../Document.scss';

const TitleComponent = ({
  canEdit,
  localTitle,
  placeholder,
  rightAlign,
  style,
  title,
  titleChangeHandler,
  updateTitle
}) => {
  const rightAlignProps = rightAlign
    ? { textAlign: 'right', iconStyle: { left: '0.5em' } }
    : {};
  return (
    <div style={Object.assign({}, { display: 'inline-block', width: '100%' }, style)}>
      {canEdit &&
        <Dthc
          desktop={TitleTextArea}
          mobile={TitleTextArea}
          placeholder={placeholder}
          title={localTitle}
          onChange={titleChangeHandler}
          commitUpdate={updateTitle}
          {...rightAlignProps}
          iconStyle={{ top: 0 }}
        >
          <div className={styles.titleTextArea}>
            {title}
          </div>
        </Dthc>}
      {!canEdit &&
        <div className={styles.titleTextArea}>
          {title}
        </div>}
    </div>
  );
};

TitleComponent.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  localTitle: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rightAlign: PropTypes.bool,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  titleChangeHandler: PropTypes.func.isRequired,
  updateTitle: PropTypes.func.isRequired
};

export default TitleComponent;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Title/Title.js